import React from 'react'
import {Container} from 'react-bootstrap'
import Demographics from "../components/patientdata/demographics/demographics";
import NavigationBar from '../components/nav';
import app from '../login/firebase'
import axios from 'axios';
import { Button } from 'react-bootstrap';
import {AuthContext} from '../login/Auth'
class ViewDemographics extends React.Component {
    static contextType = AuthContext;
    constructor(props) {
        super(props)
        this.state={
            error:null,
            isMounted:false
        }
    }
    handleGender = async (event) =>{
        var {name,value} = event.target
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                       personal_info:{
                           ...prevState.data.personal_info,
                            [name]:value
                       }
                }
            }
        ),()=>{
            if(value !="" && this.state.patient_id!=""){
                this.setState({disableSubmit:false,checkSubmit:true})
            }
            else{
                this.setState({disableSubmit:true})
            }
        })
    }
    fetchData = () =>{
        let func = this;
        const id = this.props.match.params.id
        app.auth().currentUser.getIdToken(true).then(async function(idToken){
            await fetch(process.env.REACT_APP_getDemographicsURL,{
                 method:"GET",
                 headers:{patient_id:id,'authorization':idToken,'Cache-Control': 'no-cache'}
 
             }).then( async response =>{
                 if (!response.ok){
                     func.setState({error:response.statusText})
                     throw Error(response.statusText)
                 }
                 return response.json()             
             }).then( async data=>{
                 await func.setState(prevState=>({
                     ...prevState,
                     data:data,
                     isMounted:true,
                     patient_id:id
                     
                    
                 }))
             });
         }).catch(function(error){
             func.setState({error:"Connection error: "+error})
         })
    }
    updateData =() =>{
        const func = this;
        const id = this.props.match.params.id
        app.auth().currentUser.getIdToken(true).then((idToken)=>{
            axios.post(process.env.REACT_APP_getDemographicsURL,(JSON.stringify(func.state.data)),{
                headers:{'Content-Type': 'application/json',patient_id:id,'authorization':idToken}
 
            }).then((response)=>{
                if (response.status ==200){
                    window.location.reload(false)
                }
                else{
                   alert(response.statusText)
                }
            }).catch((err)=>alert(err.response.data))
        })
      
    }
    componentDidMount() {
        // fetch("settings.json").then(function(response){
           
        //     return response.json()
        // }).then( async response=> await this.setState({fetchLink:response["getDemographicsURL"]}))
         this.fetchData()
    }
    componentDidUpdate(prevProps,prevState){
        if(this.state!=prevState){
        }
    }
    handleChange = async(field,event)=>{
        // const form  = event.currentTarget
       
       
        var {name,value} = event.target
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                   
                    data:{
                        ...prevState.data,
                        [field]:{
                            ...prevState.data[field],
                            [name] : value
                        }
                    }
            }
        ))
        
    }
    render() {
        if (this.state.isMounted){

            let {allowEdit} = this.context
            return (
                <Container fluid>
                    <NavigationBar editDemographics={true} submit={this.updateData} history={this.props.history}/>
                   
                    <Demographics data={this.state.data}  handleGender={this.handleGender}disabled={!allowEdit} handler={this.handleChange} />
                </Container> 
            )
        }
        else{
            return (
                <div>
                    Loading
                </div>
            )
        }
    }
}
export default ViewDemographics